let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kB72I")).then(() => parcelRequire('iSxaX'));